import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xl xl:text-2xl font-bold" }
const _hoisted_2 = { class: "text-sm xl:text-l opacity-70" }

import type { Detail } from "./DetailProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'DetailComponent',
  props: {
    title: {},
    description: {},
    isLast: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["px-4 xl:px-10 2xl:px-20 space-y-2 border-gray-300", {
            'border-r-0': _ctx.isLast,
            'border-r-0 md:border-r': !_ctx.isLast,
        }])
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.title), 1),
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.description), 1)
  ], 2))
}
}

})